'use client'

import { Card } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslations } from 'next-intl';
import {useRouter} from 'i18n/navigation';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function ServicesCard(props: any) {
  const { children: content, icon, title } = props;
  const router = useRouter() ;
  const t = useTranslations('home');

  return (
    <Card style={{ boxShadow: "3px 5px 10px silver" }}>
      <Card.Body style={{ display: "flex", flexDirection: "column" }}>
        <div
          style={{ height: "150px" }}
          className="d-flex justify-content-center align-items-center"
        >
          <FontAwesomeIcon size="6x" icon={icon} />
        </div>
        <div
          style={{ height: "50px", fontSize: "24px", fontWeight: "bold" }}
          className="d-flex justify-content-center align-items-center"
        >
          {title}
        </div>
        <div className="text-center pb-3">{content}</div>
        <div className="text-center">
          <button
            type="button"
            className="btn btn-outline-dark"
            onClick={() => router.push("/services")}
          >
            {t("learn_more")}
          </button>
        </div>
      </Card.Body>
    </Card>
  );
}

export default ServicesCard;
